import {FonctionLogicielle} from '../../constantes/fonctions-logicielle-constantes';
import {OperationFonction} from '../../constantes/operations-fonctions.constantes';
import {DroitModel} from '../../models/profils/droit.model';

export class AutorisationAggregate {
  constructor(readonly fonction: FonctionLogicielle, readonly operation?: OperationFonction) {}

  isAuthorizedForDroits(droits: Array<DroitModel>): boolean {    
    return droits.some(droitActif => {
      return (
        droitActif.codeFonctionLogicielle === this.fonction &&
        (!this.operation || droitActif.codesOperations.some(operation => operation === this.operation))
      );
    });
  }

  toString(): string {
    const opfonction = this.operation !== undefined ? OperationFonction[this.operation]: null;
    return `${FonctionLogicielle[this.fonction]} - ${opfonction}`;
  }
}
